export enum PortfolioReturnsStreamElementType {
    Sessions = 101,
    StartValue = 102,
    Pncs = 103,
    InitVal = 104,
}
